import { QUOTES_CODE_MAPPING } from '@fe-common-utils/libs/quote';
import { GETv2QuotesByType } from '@fe-news/api/quotes';
import queries from '@fe-news/components/ReactQuery';
import { useQuery } from '@tanstack/react-query';

const sucessStatusCode = 200;
const emptyValue = '--';
const defaultLimit = 10;
const defaultValue = {
  date: emptyValue,
  displayName: emptyValue,
  price: emptyValue,
  change: 0,
  ratio: 0,
  volunme: emptyValue
};

export const fetchHotStocksData = async ({
  type,
  limit,
  column = 'H',
  page = 0
}: {
  type: string;
  limit: number;
  column?: string;
  page?: number;
}) => {
  try {
    const response = await GETv2QuotesByType({
      type,
      column,
      page,
      limit
    });

    if (response.statusCode === sucessStatusCode) {
      return response?.data?.items ?? [];
    }

    return [];
  } catch (error) {
    console.log('HotStocks fetch error', error);
    return [];
  }
};

const formateData = (data: Quote[]) => {
  if (data.length === 0) return Array.from({ length: defaultLimit }).fill(defaultValue);

  return data.map(quote => {
    const date = (quote[QUOTES_CODE_MAPPING.TradeTime as QuoteKeys] as string) || emptyValue;
    const name = quote[QUOTES_CODE_MAPPING.ChineseName as QuoteKeys] || null;
    const shortName = quote[QUOTES_CODE_MAPPING.ShortName as QuoteKeys] || null;
    const displayName = shortName || name || emptyValue;
    const price = quote[QUOTES_CODE_MAPPING.Price as QuoteKeys] || emptyValue;
    const change = quote[QUOTES_CODE_MAPPING.Change as QuoteKeys] || '0';
    const ratio = quote[QUOTES_CODE_MAPPING.ChangePercent as QuoteKeys] || '0';
    const volume = quote[QUOTES_CODE_MAPPING.Volume as QuoteKeys] || emptyValue;
    const symbol = quote[QUOTES_CODE_MAPPING.Symbol as QuoteKeys] || emptyValue;

    return { date, displayName, price, change, ratio, volume, symbol };
  });
};

const useFetchHotStocks = ({ type, limit = 10 }: { type: string; limit?: number }) => {
  const { data, isFetching } = useQuery({
    ...queries.quotes.QuotesByType({ type, limit }),
    select: formateData,
    initialData: []
  });

  return { data: data ?? [], isLoading: isFetching };
};

export default useFetchHotStocks;
